import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';

import css from './AboutPage.module.css';
import image from './about-us-1056.jpg';

const AboutPage = () => {

  // prettier-ignore
  return (
    <StaticPage
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: 'About Eventify',
        name: 'About page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>
            <FormattedMessage id="AboutPage.title" />
          </h1>

          <div className={css.contentWrapper}>
            {/*<div className={css.contentSide}>*/}
            {/*  <h3>*/}
            {/*    <FormattedMessage id="AboutPage.asideTitle" />*/}
            {/*    <p>*/}
            {/*      <FormattedMessage id="AboutPage.asideSubTitle" />*/}
            {/*    </p>*/}
            {/*  </h3>*/}
            {/*</div>*/}

            <div>
              <div className={css.contentMainItem}>
                <h2>
                  <FormattedMessage id="AboutPage.forWhoTitle" />
                </h2>
                <p>
                  <FormattedMessage id="AboutPage.forWhoDescription" />
                </p>
              </div>

              <div className={css.contentMainItem}>
                <h2>
                  <FormattedMessage id="AboutPage.whyTitle" />
                </h2>
                <p>
                  <FormattedMessage id="AboutPage.whyDescription" />
                </p>
              </div>

              <div className={css.contentMainItem}>
                <h2>
                  <FormattedMessage id="AboutPage.eventifyTitle" />
                </h2>
                <p>
                  <FormattedMessage id="AboutPage.eventifyDescription1" />
                </p>
                <p>
                  <FormattedMessage id="AboutPage.eventifyDescription2" />
                </p>
              </div>

              <div className={css.contentMainItem}>
                <h2>
                  <FormattedMessage id="AboutPage.contactTitle" />
                </h2>
                <p>
                  <FormattedMessage
                    id="AboutPage.contactDescription"
                    values={{
                      email: <a className={css.mailLink} href="mailto:info@eventify.lv">info@eventify.lv</a>,
                      phone: <a className={css.mailLink} href="tel:+371 26866132">+371 26866132</a>
                    }}
                  />
                </p>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default AboutPage;
